module.exports = __webpack_public_path__ + "static/media/primary.42ae3a6b.png";